module.exports = __webpack_public_path__ + "static/media/14.2bc17a2d.jpg";